export default __webpack_public_path__ + "233d3a678b46007ea36f12b22865b821.svg";